import React, { useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { UPDATE_ARROW } from '../app/graphql/mutations';
import { GRAVES_QUERY } from '../app/graphql/queries';

export default function NorthArrow({ image, arrow, onFinish }) {
  const [angle, setAngle] = useState(arrow?.angle || 0);
  const [updateArrow] = useMutation(UPDATE_ARROW, {
    refetchQueries: [{ query: GRAVES_QUERY }]
  });

  if (!arrow) return null;

  const arrowCenterX = (arrow.x1 + arrow.x2) / 2;
  const arrowCenterY = (arrow.y1 + arrow.y2) / 2;

  const handleFlip = () => setAngle((angle + 180) % 360);

  const handleNext = async () => {
    if (onFinish) {
      onFinish(angle);
    } else {
      await updateArrow({ variables: { input: { id: arrow.id, angle } } });
    }
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <svg
          width="512"
          height="200"
          viewBox={`${arrow.x1} ${arrow.y1} ${arrow.x2 - arrow.x1} ${arrow.y2 - arrow.y1}`}
        >
          <image width={image.width} height={image.height} href={image.src || image.href} />
          <g
            transform={`rotate(${angle} ${arrowCenterX} ${arrowCenterY}) translate(${
              arrowCenterX - 100
            } ${arrowCenterY - 80})`}
            stroke="#3F51B5"
            shapeRendering="geometricPrecision"
          >
            <line x1="100" y1="20" x2="100" y2="150" />
            <line x1="100" x2="110" y1="20" y2="40" />
            <line x1="100" x2="90" y1="20" y2="40" />
          </g>
        </svg>
      </div>

      <div className="col-md-6">
        <button className="btn btn-info" onClick={handleFlip}>
          Flip Angle
        </button>
        <label className="form-label ms-2" htmlFor="arrow-range-input">
          Arrow Angle: {angle}°
        </label>
        <div className="range">
          <input
            id="arrow-range-input"
            type="range"
            className="form-range"
            min="0"
            max="360"
            onChange={(evt) => setAngle(evt.target.value || 0)}
            value={angle}
          />
        </div>

        <button className="btn btn-primary card-link" onClick={handleNext}>
          Next
        </button>
      </div>
    </div>
  );
}
